import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/MO-partner-badge.svg'
import _imports_1 from '@/assets/images/location-pin.svg'


const _withScopeId = n => (_pushScopeId("data-v-9733668c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "footer-container" }
const _hoisted_2 = { style: {"flex-direction":"row","display":"flex","gap":"16px"} }
const _hoisted_3 = { style: {"display":"flex","flex-direction":"column","gap":"8px"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "© 2023 Innovators Hub", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.matchoffice.be/huren/locaties/providers/groep-coenen-13144",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "MO Partner Badge"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "footer-horizontal-line" }, null, -1))
const _hoisted_7 = { style: {"text-align":"right"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Zone Guldendelle", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Arthur de Coninckstraat 5", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Kortenberg, 3070", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Vlaams Brabant, BE", -1))
const _hoisted_12 = {
  id: "footer-maps-link",
  target: "_blank",
  href: "https://www.google.com/maps/place/Arthur+de+Coninckstraat+5,+3070+Kortenberg/@50.8853159,4.5182657,16.25z/data=!4m6!3m5!1s0x47c3de7dce00f233:0x3f8b688f143e4201!8m2!3d50.8853453!4d4.5223419!16s%2Fg%2F11ghp08k27?entry=ttu"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "footer-location-icon-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Location Icon",
    width: "28"
  })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "footer-socials-container" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.facebook.com/innovatorshubkortenberg",
    target: "_blank"
  }, "Facebook"),
  /*#__PURE__*/_createElementVNode("span", null, "♦"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.linkedin.com/company/innovatorshub-kortenberg/?viewAsMember=true",
    target: "_blank"
  }, "Linkedin")
], -1))

import {getCurrentInstance} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterView',
  setup(__props) {

const instance = getCurrentInstance();
const translator = instance?.appContext.config.globalProperties.$translatorUtils;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("p", null, _toDisplayString(_unref(translator).trans("general.footer.vat")) + " " + _toDisplayString(_unref(translator).trans("general.footer.number_short")) + ": 0740.610.638 ", 1),
          _hoisted_5
        ]),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _createElementVNode("a", _hoisted_12, _toDisplayString(_unref(translator).trans("general.footer.view_on_gm")), 1)
        ]),
        _hoisted_13
      ]),
      _hoisted_14
    ])
  ]))
}
}

})